export default "__VITE_ASSET__Bd3Q1L44__"